module.exports = __webpack_public_path__ + "img/hr-tree-07-i-trunk.6494dc21.png";